<template>
  <div class="order">
    <div style="width: 100%">
      <img
        style="width: 100%"
        src="../assets/微信图片_20220316141340.jpg"
        alt=""
      />
    </div>
    <div v-if="this.$route.params.type == 1">
      <div>
        <van-field
          label="手机号"
          v-model="form.phone"
          type="tel"
          placeholder="请输入手机号"
        />
      </div>
      <div>
        <van-field
          label="验证码"
          v-model="form.random"
          center
          clearable
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              style="background-color: #e4a650; border: 1px solid #e4a650"
              size="small"
              v-if="dd == false"
              @click="change"
              type="info"
            >
              验证码
            </van-button>
            <van-button size="small" v-if="dd" disabled round>
              <van-count-down
                ref="count0"
                :time="time"
                :auto-start="false"
                format="ss"
                @finish="finishss"
              />
            </van-button>
          </template>
        </van-field>
      </div>
    </div>
    <div v-if="this.$route.params.type == 2">
      <div>
        <van-field label="姓名" v-model="form.name" placeholder="请输入姓名" />
      </div>
      <div>
        <van-field
          v-model="form.phone"
          center
          label="手机号"
          clearable
          type="tel"
          placeholder="请输入手机号"
        ></van-field>
      </div>
      <div>
        <van-field
          v-model="form.random"
          center
          label="验证码"
          clearable
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              style="background-color: #e4a650; border: 1px solid #e4a650"
              size="small"
              v-if="dd == false"
              @click="change"
              type="info"
            >
              验证码
            </van-button>
            <van-button size="small" v-if="dd" disabled round>
              <van-count-down
                ref="count0"
                :time="time"
                :auto-start="false"
                format="ss"
                @finish="finishss"
              />
            </van-button>
          </template>
        </van-field>
      </div>
    </div>
    <div v-if="this.$route.params.type == 3">
      <div>
        <van-field label="姓名" v-model="form.name" placeholder="请输入姓名" />
      </div>
      <div>
        <van-field
          v-model="form.phone"
          center
          label="手机号"
          clearable
          type="tel"
          placeholder="请输入手机号"
        ></van-field>
      </div>
      <div>
        <van-field
          v-model="form.identityCard"
          center
          label="身份证号"
          clearable
          placeholder="请输入身份证号"
        ></van-field>
      </div>
      <div>
        <van-field
          v-model="form.random"
          center
          label="验证码"
          clearable
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              style="background-color: #e4a650; border: 1px solid #e4a650"
              size="small"
              v-if="dd == false"
              @click="change"
              type="info"
            >
              验证码
            </van-button>
            <van-button size="small" v-if="dd" disabled round>
              <van-count-down
                ref="count0"
                :time="time"
                :auto-start="false"
                format="ss"
                @finish="finishss"
              />
            </van-button>
          </template>
        </van-field>
      </div>
    </div>
    <div v-if="this.$route.params.type == 4">
      <div>
        <van-field label="姓名" v-model="form.name" placeholder="请输入姓名" />
      </div>
      <div>
        <van-field
          v-model="form.phone"
          center
          label="手机号"
          clearable
          type="tel"
          placeholder="请输入手机号"
        ></van-field>
      </div>
      <div>
        <van-field
          v-model="form.identityCard"
          center
          label="身份证号"
          clearable
          placeholder="请输入身份证号"
        ></van-field>
      </div>
      <div>
        <van-field
          v-model="form.random"
          center
          label="验证码"
          clearable
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              style="background-color: #e4a650; border: 1px solid #e4a650"
              size="small"
              v-if="dd == false"
              @click="change"
              type="info"
            >
              验证码
            </van-button>
            <van-button size="small" v-if="dd" disabled round>
              <van-count-down
                ref="count0"
                :time="time"
                :auto-start="false"
                format="ss"
                @finish="finishss"
              />
            </van-button>
          </template>
        </van-field>
      </div>
    </div>
    <van-button
      style="
        margin: 20px 10px;
        padding: 10px 60px;
        background-color: #e4a650;
        border: 1px solid #e4a650;
      "
      @click="changse"
      size="medium"
      type="info"
    >
      复制ICCID号 完成实名 激活卡
    </van-button>
    <input v-show="s == 1" id="iccId" v-model="iccid" readonly type="text" />
  </div>
</template>

<script>
  import { VerificationCode, updateRealType } from "@/api/cardOperation";
  import { realAddress, getThirdPartyUrl } from "@/api/user";
  export default {
    data() {
      return {
        form: {
          random: "",
          phone: "",
          meCardNum: localStorage.getItem("meCardNum"),
          identityCard: "",
          name: "",
        },
        iccid: this.$route.params.iccId,
        dd: false,
        a: "",
        s: 0,
        time: 60 * 1000,
      };
    },
    created() {},
    mounted() {
      console.log(this.$route.params.url);
      this.ssse();
    },
    methods: {
      ssse() {
        this.axios.get(`/app/systemSettings/getAll`).then((res) => {
          if (res.data.status) {
            console.log(res);
            document.title = res.data.data.weChatWebName;
            this.a = res.data.data.footSwitch;
            if (this.$route.params.url == undefined) {
              this.$router.go(-1);
            }
          }
        });
      },
      finishss() {
        this.dd = false;
      },
      start() {
        this.$nextTick(() => {
          this.$refs.count0.start();
        });
      },
      copys() {
        console.log("测试", this.$route.params.types);
        if (this.$route.params.types == 2) {
          window.location.href = `https://ec.iot.10086.cn/authApi/service/wx/realnameH5/stepOne?channelId=RNFORWEB&iccid=${this.details.iccId}&msisdn=${this.details.realNameCard}`;
        } else if (this.$route.params.types == 1) {
          console.log("s");
        } else if (this.$route.params.types == 3) {
          console.log("s");
        } else if (this.$route.params.types == 4) {
          console.log("1");
          const upUrlLoad = this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });
          realAddress(localStorage.getItem("meCardNum"))
            .then((res) => {
              if (res.status == true) {
                window.location.href = res.msg;
                upUrlLoad.clear();
              } else {
                this.$toast.fail(res.msg);
              }
            })
            .catch(() => {
              upUrlLoad.clear();
            });
        } else if (this.$route.params.types == 5) {
          console.log("2");
          const upUrlLoad = this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });

          getThirdPartyUrl(localStorage.getItem("meCardNum"))
            .then((res) => {
              if (res.code == 0) {
                window.location.href = res.msg;
                upUrlLoad.clear();
              } else {
                this.$toast.fail(res.msg);
              }
            })
            .catch(() => {
              upUrlLoad.clear();
            });
        } else {
          window.location.href = this.$route.params.url;
        }
      },
      change() {
        if (this.form.phone == "") {
          this.$notify({
            type: "warning",
            message: `手机号不能为空`,
          });
        } else {
          VerificationCode(this.form.phone).then((res) => {
            if (res.status) {
              this.$notify({
                type: "success",
                message: res.msg,
              });
              this.dd = true;
              this.start();
            } else {
              this.$notify({
                type: "warning",
                message: res.msg,
              });
            }
          });
        }
      },
      changse() {
        updateRealType(this.form).then((res) => {
          if (res.status) {
            this.$notify({
              type: "success",
              message: res.msg,
            });
            let input = document.createElement("input");
            input.value = this.iccid;
            input.id = "creatDoms";
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input); // 执行浏览器复制命令
            this.$toast("复制成功");
            if (
              this.$route.params.isPay == false &&
              this.$route.params.realNameJudge == 3 &&
              this.$route.params.isTheMonth == false
            ) {
              this.$toast.fail("没有有效期订单，不允许官方实名");
            } else {
              this.copys();
            }
          } else {
            this.$notify({
              type: "warning",
              message: res.msg,
            });
          }
        });
      },
    },
    watch: {},
    computed: {},
  };
</script>

<style lang="scss" scoped>
  .order {
    .detail {
      width: 100%;
      margin: 20px 0;
      border-radius: 20px;
      padding-top: 10px;
      padding-bottom: 20px;
      box-sizing: border-box;
      box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
      background-color: rgba(128, 128, 128, 0.1);
    }
  }
</style>
